module.exports = __webpack_public_path__ + "img/author.8575cb17.svg";